import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  preparePapAffiliateInBrowserUrl,
  trackPostAffiliateClick,
} from "../utils/postAffiliatePro";
import { captureFbclid } from "../utils/metaPixel";

const PapAffiliateTracker = () => {
  const location = useLocation();

  useEffect(() => {
    captureFbclid();
    preparePapAffiliateInBrowserUrl();
    trackPostAffiliateClick();
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default PapAffiliateTracker;
